export default defineAppConfig({
  ui: {
    primary: 'indigo',
    gray: 'slate',
    card: {
      base: "glow-card-target",
    },
  },
});
